import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from './drought-vis.module.scss';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import ReactTooltip from 'react-tooltip';

const visColors = {
  'Fully drought declared': 'rgb(236,152,114)',
  'Partially drought declared': 'rgb(251,235,195)',
  'Not drought declared': 'rgb(227,227,227)',
};

const darkVisColors = {
  'Fully drought declared': 'rgb(161, 70, 33)',
  'Partially drought declared': 'rgb(220, 156, 58)',
  'Not drought declared': 'rgb(227,227,227)',
};

const legendItems = [
  {
    key: 'legendFullDrought',
    label: 'Fully drought declared',
    color: visColors['Fully drought declared'],
  },
  {
    key: 'legendPartialDrought',
    label: 'Partially declared',
    color: visColors['Partially drought declared'],
  },
  {
    key: 'legendNoDrought',
    label: 'Not declared',
    color: visColors['Not drought declared'],
  },
];

// Bar component
const DroughtVisBar = ({ region }) => {
  const { totalRegions, breakdown } = region;
  return (
    <div className={styles.bar}>
      {Object.entries(breakdown).map(([status, value], i) => {
        const percent = (100 / totalRegions) * value;
        return (
          <div
            key={i}
            className={styles.droughtBarSection}
            style={{
              backgroundColor: visColors[status],
              width: `${percent}%`,
              height: '100%',
            }}
            data-tip={`${status}: ${value} ${
              value === 1 ? 'council' : 'councils'
            }`}
          ></div>
        );
      })}
      <ReactTooltip multiline={true} border={true} />
    </div>
  );
};

const SingleRegion = ({ region }) => {
  const label = entityLabelMatcher(region.name, 'header');
  const { totalRegions, breakdown } = region;
  return (
    <div>
      <div>
        <span className={styles.barHeaderName}>{label}</span>
        <div className={styles.percentWrapper}>
          {Object.entries(breakdown)
            .filter(
              ([status, value]) => 
                status !== 'Not drought declared' && value !== 0 && status !== "-"
            )
            .map(([status, value], i, arr) => {
              const percent = (100 / totalRegions) * value;
              const prevVal = arr[i - 1] ? arr[i - 1][1] : 0;
              const prevPercent = (100 / totalRegions) * prevVal;
              return (
                <span
                  key={i}
                  className={styles.percentSpan}
                  style={{
                    color: darkVisColors[status],
                    left: `${prevPercent}%`,
                  }}
                >{`${percent.toFixed(0)}%`}</span>
              );
            })}
        </div>
      </div>
      <DroughtVisBar region={region} />
    </div>
  );
};

const Legend = () => {
  return (
    <div className={styles.legend}>
      {legendItems.map((item, i) => {
        return (
          <div
            key={item.key}
            className={`${styles.legendItem} ${styles[item.key]}`}
            style={{ marginRight: i < 2 ? 10 : 0 }}
          >
            <div
              className={styles.legendSquare}
              style={{
                backgroundColor: item.color,
              }}
            />
            <span className={styles.legendText}>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};

const DroughtVis = ({ droughtStatuses }) => {
  const [col1, col2] = halveArray(droughtStatuses);
  return (
    <div>
      <Legend />
      <div className={styles.barArea}>
        <div className={styles.barColumn} style={{ marginRight: '10%' }}>
          {col1.map((d, i) => {
            return <SingleRegion region={d} key={i} />;
          })}
        </div>
        <div className={styles.barColumn}>
          {col2.map((d, i) => {
            return <SingleRegion region={d} key={i} />;
          })}
        </div>
      </div>
    </div>
  );
};

const halveArray = (arr) => {
  const halfway = Math.ceil(arr.length / 2);
  return [arr.slice(0, halfway), arr.slice(halfway, arr.length)];
};

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  droughtStatuses: selectors.getDroughtStatusByRegion(state),
});

DroughtVis.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  droughtStatuses: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps, mapDispatchToProps)(DroughtVis);



// WEBPACK FOOTER //
// ./src/components/drought-vis/drought-vis.js